<section class="w-full">
    <split-header-section title="Informações Bancárias"></split-header-section>
        <div class="grid grid-nogutter nested-grid m-0">
            <div class="col-6">
                <split-card theme="secondary">
                    <ng-container card-header>
                        <div class=" flex justify-content-between">
                            <split-text theme="secondery" title="Entradas"
                            subtitle="Últimos 12 meses">
                            </split-text>
                            <split-group-filter id="filterReportRevenue" (onFilterEvent)="onFilterChange($event)">
                                <split-filter-option groupId="filterReportRevenue" field="date" [selected]="listYear[0]" label="Ano" [data]="listYear" key="date"></split-filter-option>
                            </split-group-filter>
                        </div>
                    </ng-container>
                    <ng-container card-body>
                        <split-legend-revenue [date]="graphicRevenue.currentDate" [currency]="graphicRevenue.current" [previous]="graphicRevenue.previous"></split-legend-revenue>
                        <split-line
                            [highlightLastLabel]="true"
                            [data]="graphicRevenue.data"
                            [labels]="graphicRevenue.labels"
                        ></split-line>
                    </ng-container>
                </split-card>
            </div>
            <div class="col-6">
                <split-card theme="secondary">
                    <ng-container card-header>
                        <split-text theme="secondery" title="Liquidação de recebíveis"
                        subtitle="Em tempo real">
                        </split-text>
                    </ng-container>
                    <ng-container card-body>
                        <div class="flex">
                            <div class="flex flex-column gap-5 flex-1">
                                <div class="block">
                                    <split-text theme="secondery" title="Informações Financeiras"></split-text>
                                    <split-text-key-value key="Titular" [value]="legalName || 'Não informado'"></split-text-key-value>
                                    <split-text-key-value key="Conta" [value]="taxInfo?.bankAccount?.checkingAccount || 'Não informado'"></split-text-key-value>
                                    <split-text-key-value key="Agencia" [value]="taxInfo?.bankAccount?.bankBranch || 'Não informado'"></split-text-key-value>
                                    <split-text-key-value key="Banco" [value]="taxInfo?.bankAccount?.bank?.bankFormat || 'Não informado'"></split-text-key-value>
                                </div>
                            </div>
                            <div class="flex flex-column gap-5 flex-1 mb-2">
                                <div class="flex flex-column gap-2">
                                    <split-report-message class="w-full" [width]="'100%'" [value]="splitBalance.amountCredited"
                                        [label]="'Entradas | Apenas conectadas <small class=\'opacity-60 text-xs ml-1\'>· mês atual</small>'" [bgColor]="'rgba(10, 131, 0, 0.08)'"
                                        [borderColor]="'rgba(10, 131, 0, 1)'" [disableBorder]="true"></split-report-message>
                                    <split-report-message class="w-full" [width]="'100%'" [value]="splitBalance.amountDebited"
                                        [label]="'Saídas <small class=\'opacity-60 text-xs ml-1\'>· mês atual</small>'" [bgColor]="'rgba(207, 0, 10, 0.08)'"
                                        [borderColor]="'rgba(207, 0, 10, 1)'" [disableBorder]="true"></split-report-message>
                                    <split-report-message class="w-full" [width]="'100%'" [value]="splitBalance.fee"
                                        [label]="'Taxas bancárias <small class=\'opacity-60 text-xs ml-1\'>· mês atual</small>'" [bgColor]="'rgba(153, 153, 153, 0.08)'"
                                        [borderColor]="'rgba(153, 153, 153, 1)'" [disableBorder]="true"></split-report-message>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-column">
                            <split-withdrawal-balance recipient="{{ taxInfo?.recipient }}">  </split-withdrawal-balance>
                            <p-button label="Solicitar Saque" severity="success" styleClass="w-full" (click)="openSaqueModal()"></p-button>
                        </div>
                    </ng-container>
                </split-card>
            </div>
            <div class="col-12">
                <split-card theme="secondary">
                    <ng-container card-header>
                        <div class=" flex justify-content-between">
                            <split-text theme="secondery" title="Faturamento Maquininha" subtitle="Atualização: Dados de ontem (D-1)">
                            </split-text>
                            <div class="flex justify-content-center align-items-center gap-2">
                                <split-group-filter id="filterReportMachine" (onFilterEvent)="onFilterChangeMachine($event)">
                                    <split-filter-month [required]="true" [data]="listData" groupId="filterReportMachine" field="month" label="Mês" key="month"></split-filter-month>
                                </split-group-filter>
                                <p-button pTooltip="Baixar" [rounded]="true" [text]="true" severity="secondary" (click)="csvReport()">
                                    <ng-template pTemplate="icon">
                                        <div class="flex">
                                            <split-icon name="arrow-bar-to-down" size="16"></split-icon>
                                        </div>
                                    </ng-template>
                                </p-button>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container card-body>
                        <split-table [paginator]="true" [totalRecords]="totalRecords" (pageChange)="pageChange($event)" [loading]="loadingMachineOrder"  [dados]="listMachineOrders">
                            <ng-template #parentHeader>
                                <th colspan="6">Transação</th>
                                <th colspan="4">Receita</th>
                            </ng-template>
                             <ng-template #header>Id</ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                {{item.id}}
                            </ng-template>
                            <ng-template #header>Data e hora</ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                {{item.createdAt | date:'dd/MM/yyyy HH:mm'}}
                            </ng-template>
                              <ng-template #header>Forma de pagamento</ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                {{item.paymentMethodName}}
                            </ng-template>
                            <ng-template #header><split-tooltip-text text="Split profissional" tooltipText="O Valor splitado representa o montante bruto enviado para a conta bancária, antes das deduções finais de taxas."></split-tooltip-text></ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                {{item.effectiveProfessionalAmount | currency:'BRL'}}
                            </ng-template>
                             <ng-template #header><split-tooltip-text text="Split unidade" tooltipText="O Valor splitado representa o montante bruto enviado para a conta bancária, antes das deduções finais de taxas."></split-tooltip-text></ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                {{item.effectiveClinicAmount | currency:'BRL'}}
                            </ng-template>
                               <ng-template #header><split-tooltip-text text="Taxas" tooltipText="Estes cálculos de taxas são aproximados. O valor final pode variar conforme o sistema de pagamento processa a transação ou se nossos termos e condições forem atualizados."></split-tooltip-text></ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                <span class="underline cursor-pointer" [pTooltip]="tooltipFee">
                                    {{(item.paymentFeeAmount + item.operationFeeAmount + item.anticipationFeeAmount) | currency:'BRL'}}
                                </span>
                                <ng-template #tooltipFee>
                                    <p class="m-0">MDR: {{item.paymentFeeAmount | currency:'BRL'}}</p>
                                    <p class="m-0">Antecipação: {{item.anticipationFeeAmount | currency:'BRL'}}</p>
                                    <p class="m-0">Operação SplitPay: {{item.operationFeeAmount | currency:'BRL'}}</p>
                                </ng-template>
                            </ng-template>
                            <ng-template #header>Id</ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                {{item.revenueId}}
                            </ng-template>
                            <ng-template #header>Paciente</ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                {{item.payerName}}
                            </ng-template>
                            <ng-template #header>
                                <split-tooltip-text text="Valor" tooltipText="Valor total da receita"></split-tooltip-text>
                            </ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                {{item.revenueAmount | currency:'BRL'}}
                            </ng-template>
                            <ng-template #header>Status</ng-template>
                            <ng-template #coluna let-item="dadosLinha">
                                <split-icon-status [status]="item.machineOrderStatus"></split-icon-status>
                            </ng-template>
                        </split-table>
                        <ng-template #tooltipValueLiquid>
                            <p class="mt-0">Valor final recebido após as taxas da maquininha (MDR e Antecipação).</p>

                            <p class="m-0">Exemplo de cálculo:</p>
                            <p class="m-0">Valor Dividido: R$ 297,00</p>
                            <p class="m-0">Taxa MDR: - R$ 3,00</p>
                            <p class="m-0">Taxa Antecipação: - R$ 5,00</p>
                            <p class="m-0">Taxa SplitPay  RS ,00</p>
                            <p class="m-0">Valor Líquido Final: R$ 289,00</p>
                        </ng-template>
                    </ng-container>
                </split-card>
            </div>
        </div>
</section>
